import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Icon } from '@adc/ui-adc'
import classnames from 'classnames/bind'
import { ARVSortOptionsOrder } from '../../constants/sorting'
import { getUpdatedSortObject, getSortOrderIcon } from '../../util/sorting'
import SortDropdown from '../sortDropdown'
import styles from './styles.scss'
const cx = classnames.bind(styles)

class ListHeaders extends Component {
  static propTypes = {
    elmId: PropTypes.string.isRequired,
    filters: PropTypes.object.isRequired,
    featureFlags: PropTypes.object.isRequired,
    updateSorting: PropTypes.func.isRequired,
  }

  updateSortingAction = value => {
    const { filters, updateSorting } = this.props
    const updatedSortValue = getUpdatedSortObject(value, filters)
    updateSorting(updatedSortValue)
  }

  getSortDropdownTitle = (selectedValue, sortOrder) => {
    const selectedOrder = ARVSortOptionsOrder.find(
      option => option.value === selectedValue
    )
    return (
      <>
        <Icon
          className={cx('sort-icon')}
          name={
            sortOrder === 'desc' ? 'sort-amount-down' : 'sort-amount-up-alt'
          }
          color='info'
          iconStyle='regular'
        />{' '}
        Sort {selectedOrder?.text ? ` By: ${selectedOrder.text} ` : ''}
      </>
    )
  }

  getSortIcon = () => {
    const { filters } = this.props
    return getSortOrderIcon(filters.sort.order)
  }

  render() {
    const { elmId, filters, featureFlags } = this.props
    const { type: sortType, order: sortOrder } = filters.sort
    return (
      <div
        data-elm-id={elmId}
        className={cx('asset-headers-root', 'u-ml-3', 'u-mr-3')}
      >
        <div className={cx('sort-container')}>
          <SortDropdown
            onSelect={this.updateSortingAction}
            selectedDirection={sortOrder}
            selectedValue={sortType}
            featureFlags={featureFlags}
            elmId={elmId}
            title={this.getSortDropdownTitle(sortType, sortOrder)}
          />
        </div>
      </div>
    )
  }
}

export default ListHeaders
